module.exports = __webpack_public_path__ + "static/media/ed3.5fac0758.jpg";